import { Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import ListAnsc from '../../../../../../shared/list-ansc';
import { ItemVM } from 'shell/view-models/item';

interface GeneralDataLackConsentProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
}

const GeneralDataLackConsentComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
}: GeneralDataLackConsentProps): React.ReactElement => {
  const handleListReasonLackConsent = useEventCallback((item?: ItemVM) => {
    onChange('reasonLackConsent', item?.id);
  });

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <ListAnsc
          label="Motivo del mancato consenso"
          idDominio="35"
          value={values?.reasonLackConsent || ''}
          onChange={handleListReasonLackConsent}
          disabled={disabled}
          error={Boolean(errors?.reasonLackConsent) && touched?.reasonLackConsent}
          required
        />
      </Grid>
    </Grid>
  );
};

GeneralDataLackConsentComponent.displayName = 'Form General Data Lack Consent component';

const GeneralDataLackConsent = memo(GeneralDataLackConsentComponent);

export default GeneralDataLackConsent;
